import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { SelectDropdownItem } from '@/types';

import FormErrorV2 from '@/components/common/form/FormErrorV2';

import Dropdown from '@/components/common/design-system/Dropdown.ds';

export type SelectFieldV2Props = {
  id?: string;
  label?: string;
  name: string;
  required?: boolean;
  onChange?: (selected: number | string) => void | Promise<void>;
  selected?: number | string;
  options?: SelectDropdownItem[];
  favorites?: SelectDropdownItem[];
  defaultValue?: string | number;
  rbf?: string;
  hintMessage?: string;
};

export const SelectFieldV2 = (props: SelectFieldV2Props): React.JSX.Element => {
  const { name, required = false, hintMessage } = props;

  const { register, setValue, formState: { errors } } = useFormContext();

  const [selectedValue, setSelected] = useState<number | string>(props.defaultValue || props.selected);

  const handleChange = (element: number | string) : void => {
    setSelected(element);
    setValue(name, element);
    props.onChange?.(element);
  };

  return (
    <>
      <Dropdown
        {...props}
        {...register(name, { required })}
        onBlur={handleChange}
        onChange={handleChange}
        defaultValue={props.defaultValue}
        value={selectedValue}
        hintMessage={hintMessage}
      />
      {errors?.[name] && <FormErrorV2 error={errors[name]} />}
    </>
  );
};

export default SelectFieldV2;
